// Investment.js
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Col, Row, CardHeader, Button } from 'reactstrap';
import { IoAddOutline } from 'react-icons/io5';
import base from '../Services/BaseService';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authconfig';
import InvestmentModal from './InvestmentModal';
import InvestmentMultiModal from './InvestmentMultiModal';
import Grid from './Shared/Grid';
import LoadSpinner from './Shared/Loading';
import '../App.css';
import '../Assets/css/Main.css';

const Investment = () => {
    const gridRef = useRef();
    const [investmentData, setInvestmentData] = useState([]);
    const [investmentPots, setInvestmentPots] = useState([]);
    const [saveItem, setSaveItem] = useState();
    const [investmentID, setInvestmentID] = useState();
    const [activeModal, setActiveModal] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [expLoading, setExpLoading] = useState(true);
    const { instance, accounts } = useMsal();

    const currencyFormatter = useCallback((params) => {
        const number = params.value || 0;
        return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$&,');
    }, []);

    const initGridVar = useCallback(() => ({
        flex: 1,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: false,
        editable: false,
        sortingOrder: ["asc", "desc"],
    }), []);

    const [gridDefaultColDef] = useState(initGridVar);

    const [budgetColDef] = useState([
        { headerName: "Post Date", field: "postDate", maxWidth: 95, valueGetter: (params) => (params.data.postDate || "").split("T")[0] },
        { headerName: "Account Id", field: "accountId", maxWidth: 100 },
        { headerName: "Fund Name", field: "fundName", maxWidth: 200 },
        { headerName: "Invested", field: "bookCost", filter: 'agNumberColumnFilter', type: 'numericColumn', maxWidth: 125, valueFormatter: currencyFormatter },
        { headerName: "Price", field: "fundPrice", filter: 'agNumberColumnFilter', type: 'numericColumn', maxWidth: 125, valueFormatter: currencyFormatter },
        { headerName: "Valuation", field: "fundValuation", filter: 'agNumberColumnFilter', type: 'numericColumn', maxWidth: 125, valueFormatter: currencyFormatter },
        { headerName: "id", field: "id", hide: true },
    ]);

    const tokenRefresh = useCallback(async () => {
        try {
            const response = await instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
            sessionStorage.setItem("authheader", `Bearer ${response.idToken}`);
        } catch {
            console.error("Token error");
        }
    }, [accounts, instance]);

    const getInvestmentData = async () => {
        try {
            const investmentRes = await base.getAll("Investment");
            setInvestmentData(investmentRes);
            const investmentFunds = await base.getAll("Investment/fundvalue");
            setInvestmentPots(investmentFunds);
            // const potsMap = new Map();

            // investmentRes.forEach(item => {
            //     if (item.fundName && item.accountId) {
            //         const key = `${item.fundName}-${item.accountId}`; // unique combo
            //         if (!potsMap.has(key)) {
            //             potsMap.set(key, {
            //                 fundName: item.fundName,
            //                 accountId: item.accountId,
            //                 accountName: item.accountName
            //             });
            //         }
            //     }
            // });
            // const pots = Array.from(potsMap.values());
            // console.log("Investment pots:", pots);
            // setInvestmentPots(pots);      
        } catch (err) {
            console.error("Load error", err);
        }
    };


    useEffect(() => {
        tokenRefresh().then(() => {
            getInvestmentData();
            setTimeout(() => setExpLoading(false), 1000);
        });
    }, [saveItem, tokenRefresh]);

    const openModal = (type) => setActiveModal(type);
    const closeModal = () => {
        setActiveModal(null);
        setInvestmentID(null);
        setIsEdit(false);
    };

    const onSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length === 1) {
            setInvestmentID(selectedRows[0].id);
            setIsEdit(true);
            openModal('single');
        }
    };

    return (
        <>
            <CardHeader className="pt-3 pb-3">
                <Row>
                    <Col xs="6" className="page-header">Investments</Col>
                    <Col xs="6" className="text-end pe-4">
                        <Button size="sm" color="dark" className="btn-text me-2" onClick={() => openModal('multi')}>
                            <IoAddOutline size={24} style={{ color: "#fff" }} />
                        </Button>
                    </Col>
                </Row>
            </CardHeader>

            {expLoading ? (
                <LoadSpinner />
            ) : (
                <div className="pt-2 pb-2 res-padding scroll-container">
                    <Grid
                        onSelectionChanged={onSelectionChanged}
                        gridDefaultColDef={gridDefaultColDef}
                        colDef={budgetColDef}
                        data={investmentData}
                        gridRef={gridRef}
                    />
                </div>
            )}

            {activeModal === 'single' && (
                <InvestmentModal
                    id={investmentID}
                    closeModal={closeModal}
                    showModalForm={true}
                    tokenRefresh={tokenRefresh}
                    setSaveItem={setSaveItem}
                    isEdit={isEdit}
                />
            )}

            {activeModal === 'multi' && (
                <InvestmentMultiModal
                    closeModal={closeModal}
                    showModalForm={true}
                    setSaveItem={setSaveItem}
                    investmentPots={investmentPots}
                />
            )}
        </>
    );
};

export default Investment;
